import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorUsdc = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M3.25 12a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0ZM12 1.75C6.34 1.75 1.75 6.34 1.75 12S6.34 22.25 12 22.25 22.25 17.66 22.25 12 17.66 1.75 12 1.75Zm-1.77 4.777A.75.75 0 0 0 9.77 5.1a7.253 7.253 0 0 0 0 13.8.75.75 0 1 0 .46-1.427 5.753 5.753 0 0 1 0-10.946Zm4-1.427a.75.75 0 0 0-.46 1.427 5.753 5.753 0 0 1 0 10.946.75.75 0 0 0 .46 1.427 7.253 7.253 0 0 0 0-13.8Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      d="M12.665 16.688c0 .171-.14.312-.312.312h-.625a.313.313 0 0 1-.313-.313v-.984c-1.367-.187-2.03-.945-2.21-1.992a.288.288 0 0 1 .289-.336h.71c.149 0 .274.11.305.25.133.617.492 1.094 1.586 1.094.805 0 1.383-.453 1.383-1.125 0-.672-.336-.93-1.523-1.125-1.75-.235-2.579-.766-2.579-2.133 0-1.055.805-1.883 2.04-2.055v-.969c0-.171.14-.312.312-.312h.625c.172 0 .313.14.313.313v.992c1.007.18 1.648.75 1.859 1.703a.287.287 0 0 1-.29.344h-.655a.31.31 0 0 1-.297-.227c-.18-.602-.61-.867-1.36-.867-.828 0-1.258.398-1.258.96 0 .595.243.891 1.516 1.071 1.719.234 2.61.727 2.61 2.188 0 1.109-.829 2.007-2.118 2.21v1h-.008Z"
    />
  </svg>
);
export default SvgTwoColorUsdc;
